import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseAdvanceMaintenanceDirectiveDiagnosticEntryProps {
  directiveEntryId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useAdvanceMaintenanceDirectiveDiagnosticEntry = ({
  directiveEntryId,
  options,
}: UseAdvanceMaintenanceDirectiveDiagnosticEntryProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['maintenanceTransportAutoEntriesComplete'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/directive/diagnostic_entries/${directiveEntryId}/advance`);
    },
    ...options
  });
}
